import { useState } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";

const Nav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <div className="logo-circle">
              <img
                src="./assets/bloodlogo.png"
                alt="Logo"
                className="logo-image"
              />
            </div>
            <span className="logo-text">SarvSahayataSangathan</span>
          </Link>
        </div>

        <nav className="navbar-links">
          <Link to="/">Home</Link>
          <Link to="/admin/dashboard">Admin</Link>
          <Link to="/about">About</Link>
          <Link to="/support">Support & Cases</Link>
          <Link to="/legal">Our Legal Identity</Link>
          <a href="#contactus-form">Contact Us</a>
          {/* <a href="#save-lives-section">Register</a> */}
        </nav>

        <div className="navbar-buttons">
          <Link to="/login" className="btn-outline">
            Log in
          </Link>
        </div>
        <button className="menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-links">
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
            <Link
              to="/admin/dashboard"
              onClick={() => setMobileMenuOpen(false)}
            >
              Admin
            </Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)}>
              About
            </Link>
            <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
              Support & Cases
            </Link>
            <Link to="/legal" onClick={() => setMobileMenuOpen(false)}>
              Our Legal Identity
            </Link>
            <a href="#contactus-form">Contact Us</a>
          </nav>
          <div className="mobile-buttons">
            <Link
              to="/login"
              className="btn-outline"
              onClick={() => setMobileMenuOpen(false)}
            >
              Log in
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
